module.exports = __webpack_public_path__ + "img/icon-edit.784893c3.svg";